import React, { useLayoutEffect, useState } from 'react';

const ResponsiveSvgComponent = () => {
  const [svgSize, setSvgSize] = useState({ width: 304, height: 140 });

  useLayoutEffect(() => {
    const updateSvgSize = () => {
      const width = window.innerWidth;
      if (width <= 1920) {
        setSvgSize({ width: 250, height: 115 }); // Размеры для fullHD
      } else {
        setSvgSize({ width: 304, height: 140 }); // Оригинальные размеры
      }
    };

    updateSvgSize();
    window.addEventListener('resize', updateSvgSize);
    return () => window.removeEventListener('resize', updateSvgSize);
  }, []);

  return (
    <svg
      width={svgSize.width}
      height={svgSize.height}
      viewBox="0 0 304 140"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.40459 126.736L1.40466 126.736C28.6432 71.2088 70.6129 28.2785 112.779 9.02848C137.696 -2.34285 166.312 -2.34281 191.221 9.02848C233.387 28.2785 275.349 71.2088 302.595 126.736L303.044 126.516L302.595 126.736C305.431 132.513 301.254 139.249 294.811 139.249H152.004H9.18919C2.74558 139.249 -1.4314 132.513 1.40459 126.736Z"
        fill="#F5EBD3"
        stroke="#F5EBD3"
      />
    </svg>
  );
};

export default ResponsiveSvgComponent;
